import React, { useContext, useEffect, useState } from "react";
import { Button } from "../../../../../../stories/Button/Button";
import useFormJson from "../../../../../../json/useFormJson";
import { LabelProps } from "../../../../../../utils/types";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import { Junction } from "./queries/types";
import { nodeVar } from "../../../../../../utils/commonQueryTypes";
import { useLazyQuery } from "@apollo/client";
import { GetJunctionNode } from "./queries/queries";
import { AppContext } from "../../../../../../context/context";
import { Label } from "../../../../../../stories/Label/Label";
import { EMPTY_STRING, emptyMessage } from "../../../../../../utils/constants";
import Input from "../../../../../../stories/Input/Input";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import { getDownloadUrl } from "../../../../../../utils/DownloadFile";
import DocumentsDownload from "../../../../../../images/DocumentsDownload.svg";
import Gallery from "../../../../../../images/DownloadImage.svg";
import { Operation } from "../../../../../../utils/Enum.types";
import image from "../../../../../../images/Formatter Icons/image.svg";
import { ViewTicketModalStyles } from "../../../../../../styles/CustomModalStyles";
import { CustomModal } from "../../../../../../utils/UtilFunctions";
import MessageModal from "../../../../../../customComponents/MessageModal";

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}
const ParticuarJunctionDetails = ({ setModalFlag }: Props) => {
  const { JunctionsFormLabels } = useFormJson();
  const { state } = useContext(AppContext);
  const [mutationCompleted, setMutationCompleted] = useState(false);
  const [imageData, setImageData] = useState<{
    filename: string;
    url: string;
  }>({ filename: "", url: "" });
  const [imageModal, setImageModal] = useState(false);
  const [message, setMessage] = useState(emptyMessage);

  const [GetJunctionByNode, { data: junctionData }] = useLazyQuery<
    { node: Junction },
    nodeVar
  >(GetJunctionNode);
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (state.junctionID) {
          GetJunctionByNode({
            variables: {
              id: state.junctionID,
            },
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [state.companyId, GetJunctionByNode]);

  const handleClear = () => {
    setMessage(emptyMessage);
  };

  return (
    <>
      <div className="view-junctions">
        <div className="view-junctions__title">
          <Title>{junctionData ? junctionData.node.name : EMPTY_STRING}</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        <div className="view-junctions__block">
          {JunctionsFormLabels.map((field: LabelProps, key: React.Key) => {
            if (field.dataType === "textarea") {
              return (
                <React.Fragment key={key}>
                  <div className="label-grid">
                    <Label>{field.labelName}</Label>
                    <TextArea
                      value={
                        junctionData ? junctionData.node.address : EMPTY_STRING
                      }
                      rows={3}
                      disabled
                    />
                  </div>
                </React.Fragment>
              );
            }
            // else if (field.dataType === "icon") {
            //   return (
            //     <IconSelect
            //       onChange={(newValue) => {
            //         if (newValue) {
            //           setFormData({
            //             ...formData,
            //             icon: newValue.value as unknown as string,
            //           });
            //         } else {
            //           setFormData({
            //             ...formData,
            //             icon: "",
            //           });
            //         }
            //       }}
            //     />
            //   );
            // }
            else {
              return (
                <React.Fragment key={key}>
                  <div className="label-grid">
                    <Label>{field.labelName}</Label>

                    <Input
                      value={
                        junctionData?.node[field.inputName as keyof Junction] ??
                        EMPTY_STRING
                      }
                      disabled
                    />
                  </div>
                </React.Fragment>
              );
            }
          })}
          <div className="label-grid">
            <Label>Images</Label>
            <div className="d-flex">
              {junctionData && junctionData.node && junctionData.node.images
                ? junctionData.node.images.split(";").map((res, index) => (
                    <div
                      key={index}
                      onClick={async () => {
                        try {
                          setMutationCompleted(true);
                          const ext = res.split(".").pop();
                          const filename = `${junctionData.node.companyID}/junctionDetails/${junctionData.node.id}_${index}.${ext}`;
                          const ers = await getDownloadUrl(filename, false);
                          setImageData({
                            filename: filename,
                            url: ers,
                          });
                          setImageModal(true);
                          setMutationCompleted(false);
                        } catch (error) {
                          setMutationCompleted(false);
                          setMessage({
                            flag: true,
                            message: "Failed to fetch image",
                            operation: Operation.NONE,
                          });
                        }
                      }}
                    >
                      <img src={image} alt="" /> {index}
                    </div>
                  ))
                : null}
            </div>
          </div>
        </div>

        <Button mode="cancel" onClick={() => setModalFlag(false)} />

        <CustomModal
          isOpen={imageModal}
          onRequestClose={() => setImageModal(!imageModal)}
          contentComponent={
            <div className="import-excel-data__modal">
              <div className="import-excel-data--title">
                <img
                  className="me-5"
                  src={DocumentsDownload}
                  alt=""
                  onClick={async () => {
                    try {
                      setMutationCompleted(true);
                      const ers = await getDownloadUrl(
                        imageData.filename,
                        true
                      );

                      setMutationCompleted(false);
                    } catch (error) {
                      setMutationCompleted(false);
                      setMessage({
                        flag: true,
                        message: "Failed to fetch image",
                        operation: Operation.NONE,
                      });
                    }
                  }}
                />
                <img
                  src={Close}
                  alt=""
                  onClick={() => {
                    setImageModal(false);
                  }}
                />
              </div>

              <div className="view-image">
                <img src={imageData.url ? imageData.url : Gallery} alt="/" />
              </div>
            </div>
          }
          style={ViewTicketModalStyles}
        />
      </div>
      <MessageModal
        modalFlag={message.flag!}
        value={message.message!}
        handleClose={handleClear}
        operation={message.operation!}
      />
    </>
  );
};

export default ParticuarJunctionDetails;
